import { TagSelector } from "app/components/common/TagSelector";
import { selUserTags } from "app/routes/dashboard/routes/generalSettings/components/TagTab/slice/tagSlice";
import { getUserTags } from "app/routes/dashboard/routes/generalSettings/components/TagTab/slice/tagThunks";
import React, { memo, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
/* -------------------------------------------------------------------------- */
export const TagsSelector = memo(({ selected, onChange }) => {
  const dispatch = useDispatch();
  const tagsList = useSelector(selUserTags);
  const tagOptions = useMemo(
    () =>
      tagsList?.map((tag) => ({
        id: tag.id,
        value: tag.tag,
        color: tag.colour,
      })),
    [tagsList]
  );
  /* -------------------------------------------------------------------------- */
  useEffect(() => {
    dispatch(getUserTags());
  }, []);
  /* -------------------------------------------------------------------------- */
  return (
    <TagSelector
      label="Tags"
      options={tagOptions}
      selected={selected}
      onChange={onChange}
    />
  );
});
